import React from 'react';
import { DocumentManagementScreen } from './components/DocumentManagementScreen';
import { DetachedViewer } from './components/DetachedViewer';
export function App() {
  // Check if this is the detached viewer window
  const isDetachedViewer = window.location.search.includes('viewer=detached');
  if (isDetachedViewer) {
    return <DetachedViewer data-id="element-0" />;
  }
  return <DocumentManagementScreen data-id="element-1" />;
}